/**
 * Single place for signup API defaults used by client.service.js and forms.
 * Set REACT_APP_DEFAULT_ENTITY / REACT_APP_DEFAULT_AGENT_ID in .env (restart dev server after changes).
 */

const trimEnv = (key) => {
  const v = typeof process !== "undefined" ? process.env[key] : undefined;
  return v != null ? String(v).trim() : "";
};

/** Canonical CRM entity for this product (backend checks e.g. `params.entity === "GODOFS"`). Not FSC/FSA/SCA UI codes. */
export const DEFAULT_CRM_ENTITY = "GODOFS";

/** Same as CRM entity; env may override for non–iTrade-Pro builds only. */
export const DEFAULT_SIGNUP_ENTITY =
  trimEnv("REACT_APP_DEFAULT_ENTITY") || DEFAULT_CRM_ENTITY;

export const DEFAULT_SIGNUP_AGENT_ID = trimEnv("REACT_APP_DEFAULT_AGENT_ID") || "457";
